const BASE = 'https://exercisedb.p.rapidapi.com';

function headers() {
  return {
    'X-RapidAPI-Key': import.meta.env.VITE_RAPIDAPI_KEY || '',
    'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com',
  };
}

export async function getExercisesByBodyPart(bodyPart, limit = 20) {
  if (!import.meta.env.VITE_RAPIDAPI_KEY) return getMockExercises(bodyPart);
  const res = await fetch(`${BASE}/exercises/bodyPart/${encodeURIComponent(bodyPart)}?limit=${limit}&offset=0`, { headers: headers() });
  if (!res.ok) return getMockExercises(bodyPart);
  return res.json();
}

export async function getExercisesByMuscle(muscle, limit = 20) {
  const res = await searchExercises(muscle, limit);
  return res.length ? res : getMockExercises(muscle);
}

export async function searchExercises(query, limit = 20) {
  if (!import.meta.env.VITE_RAPIDAPI_KEY) return getMockExercises(query).filter((e) => e.name.toLowerCase().includes(query.toLowerCase()));
  const res = await fetch(`${BASE}/exercises/name/${encodeURIComponent(query)}?limit=${limit}&offset=0`, { headers: headers() });
  if (!res.ok) return [];
  return res.json();
}

export async function getExerciseById(id) {
  if (!import.meta.env.VITE_RAPIDAPI_KEY) {
    return getMockExercises('all').find((e) => e.id === id) || null;
  }
  const res = await fetch(`${BASE}/exercises/exercise/${id}`, { headers: headers() });
  if (!res.ok) return null;
  return res.json();
}

export async function getBodyPartList() {
  if (!import.meta.env.VITE_RAPIDAPI_KEY) {
    return ['chest', 'back', 'shoulders', 'upper arms', 'upper legs', 'lower legs', 'waist', 'cardio', 'neck', 'lower arms'];
  }
  const res = await fetch(`${BASE}/exercises/bodyPartList`, { headers: headers() });
  if (!res.ok) return ['chest', 'back', 'shoulders', 'upper arms', 'upper legs', 'lower legs', 'waist', 'cardio', 'neck', 'lower arms'];
  return res.json();
}

function getMockExercises(bodyPart) {
  return [
    { id: '0001', name: 'Barbell Back Squat', bodyPart: 'upper legs', equipment: 'barbell', target: 'quadriceps', gifUrl: 'https://v2.exercisedb.io/image/5YHEMBUmkfRFJV', instructions: ['Stand with feet shoulder-width', 'Squat down keeping chest up', 'Drive through heels'] },
    { id: '0002', name: 'Bench Press', bodyPart: 'chest', equipment: 'barbell', target: 'pectorals', gifUrl: 'https://v2.exercisedb.io/image/dLUHy3gzWMRNQ-', instructions: ['Lie on bench', 'Grip bar wider than shoulders', 'Lower to chest and press up'] },
    { id: '0003', name: 'Deadlift', bodyPart: 'back', equipment: 'barbell', target: 'spine', gifUrl: 'https://v2.exercisedb.io/image/Jj2W5KFmBBGBjE', instructions: ['Stand over bar', 'Hinge at hips', 'Drive hips forward to stand'] },
    { id: '0004', name: 'Pull-up', bodyPart: 'back', equipment: 'body weight', target: 'lats', gifUrl: 'https://v2.exercisedb.io/image/QG9VWRNlMLRRzA', instructions: ['Hang from bar', 'Pull chest to bar', 'Lower with control'] },
    { id: '0005', name: 'Overhead Press', bodyPart: 'shoulders', equipment: 'barbell', target: 'delts', gifUrl: 'https://v2.exercisedb.io/image/5YHEMBUmkfRFJV', instructions: ['Hold bar at shoulder height', 'Press directly overhead', 'Lock out at top'] },
    { id: '0006', name: 'Romanian Deadlift', bodyPart: 'upper legs', equipment: 'barbell', target: 'hamstrings', gifUrl: 'https://v2.exercisedb.io/image/Jj2W5KFmBBGBjE', instructions: ['Hinge at hips', 'Keep bar close to legs', 'Feel stretch in hamstrings'] },
    { id: '0007', name: 'Incline Dumbbell Press', bodyPart: 'chest', equipment: 'dumbbell', target: 'pectorals', gifUrl: 'https://v2.exercisedb.io/image/dLUHy3gzWMRNQ-', instructions: ['Set bench to 30-45 degrees', 'Press dumbbells up', 'Lower with control'] },
    { id: '0008', name: 'Lat Pulldown', bodyPart: 'back', equipment: 'cable', target: 'lats', gifUrl: 'https://v2.exercisedb.io/image/QG9VWRNlMLRRzA', instructions: ['Grip bar wide', 'Pull to upper chest', 'Squeeze lats at bottom'] },
  ].filter((e) => !bodyPart || bodyPart === 'all' || e.bodyPart === bodyPart || e.target?.includes(bodyPart));
}
